import { css } from 'styled-components';
import { listResetMixin } from '../listResetMixin';
import { spacingMixin } from '../spacingMixin';

/** @class VerticalNavListMixin */
/** @method */

export var VerticalNavListMixin = function VerticalNavListMixin(props) {
  return css(["", " ", ""], listResetMixin, spacingMixin(props));
};